/* SAMANSA product page — variant selection */
(function () {
  'use strict';
  var data = window.SAMANSA_PRODUCT;
  if (!data || !data.variants || data.variants.length === 0) return;

  // Show "残り◯点" only at or below this quantity (keep in sync with
  // the 残りわずか threshold in snippets/samansa-product-card.liquid).
  var LOW_STOCK = 5;

  // If the product has no buyer-selectable options (only the default variant),
  // skip variant matching — the first/only variant is always the answer.
  var hasOptions = document.querySelectorAll('.prod-option').length > 0;

  var selected = []; // current selected option values per option index
  document.querySelectorAll('.prod-option').forEach(function (opt) {
    var idx = parseInt(opt.dataset.optionIndex, 10);
    var activeBtn = opt.querySelector('.prod-opt-btn.is-active');
    selected[idx] = activeBtn ? activeBtn.dataset.optionValue : null;
    var displayEl = opt.querySelector('[data-option-display]');
    if (displayEl && activeBtn) displayEl.textContent = ' — ' + activeBtn.dataset.optionValue;
  });

  function findVariant() {
    if (!hasOptions) return data.variants[0];
    return data.variants.find(function (v) {
      return v.options.every(function (val, i) { return selected[i] === val; });
    });
  }

  // Find the gallery figure for a variant.
  // 1) Prefer the variant's assigned image (featured_image id).
  // 2) Fallback: match an image whose alt ends with the selected option value,
  //    e.g. alt "Sticker Set – A" for value "A" (lets it work even when the
  //    variant image isn't formally linked in admin, as long as images are
  //    named per set).
  function findVariantFigure(v) {
    if (v.image_id) {
      var byId = document.querySelector('.prod-image--main[data-image-id="' + v.image_id + '"]');
      if (byId) return byId;
    }
    var val = (selected[0] || '').trim();
    if (!val) return null;
    var esc = val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('[\\s\\-–—:：(（]' + esc + '\\s*[)）]?\\s*$', 'i');
    var figs = document.querySelectorAll('.prod-image--main');
    for (var i = 0; i < figs.length; i++) {
      var img = figs[i].querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      if (re.test(alt)) return figs[i];
    }
    return null;
  }

  var isInitialApply = true;

  function applyVariant() {
    var v = findVariant();
    var hiddenId = document.getElementById('prod-variant-id');
    var btn = document.getElementById('prod-add-btn');
    var labelEl = document.getElementById('prod-add-label');
    var priceEl = document.getElementById('prod-price-amount');

    if (!v) {
      if (btn) { btn.disabled = true; }
      if (labelEl) labelEl.textContent = '組み合わせ無し';
      return;
    }

    if (hiddenId) hiddenId.value = v.id;
    if (priceEl) priceEl.textContent = v.price;

    // Low-stock line: "S 残り3点" (hidden when stock is healthy or untracked)
    var stockEl = document.getElementById('prod-stock');
    if (stockEl) {
      if (v.tracked && v.inv > 0 && v.inv <= LOW_STOCK) {
        stockEl.textContent = '△ ' + (hasOptions ? v.title + ' ' : '') + '残り' + v.inv + '点';
      } else {
        stockEl.textContent = '';
      }
    }
    var isPresale = btn && btn.getAttribute('data-presale') === 'true';
    if (btn) btn.disabled = isPresale || !v.available;

    // 再入荷のお知らせ：売り切れのサイズを選んだときだけ出し、登録タグをそのサイズに合わせる
    var rs = document.getElementById('prod-restock');
    if (rs) {
      rs.hidden = isPresale || v.available;
      var rsTags = document.getElementById('prod-restock-tags');
      if (rsTags) rsTags.value = 'restock, ' + (rs.getAttribute('data-tag-base') || '') + (hasOptions ? ':' + v.title : '');
      var rsSize = document.getElementById('prod-restock-size');
      if (rsSize) rsSize.textContent = hasOptions ? v.title + ' の' : '';
    }
    if (labelEl) {
      labelEl.textContent = (isPresale || !v.available) ? 'SOLD OUT' : 'カートに追加する';
    }

    // Bring the selected variant's image into view.
    // Gallery is a vertical stack on desktop / horizontal carousel on mobile,
    // so we scroll to the matching figure (no scroll on initial page load).
    var targetFig = findVariantFigure(v);
    if (targetFig) {
      document.querySelectorAll('.prod-image--main').forEach(function (f) { f.classList.remove('is-active'); });
      targetFig.classList.add('is-active');
      if (!isInitialApply) {
        // スマホ（横スライド）は画像の列だけを横に動かし、ページは縦に動かさない
        var track = targetFig.parentElement;
        if (track && track.scrollWidth > track.clientWidth + 1) {
          track.scrollTo({ left: targetFig.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        } else {
          targetFig.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        }
      }
    }
    isInitialApply = false;

    // Reflect variant id in URL
    if (history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u.toString());
    }
  }

  document.querySelectorAll('.prod-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.optionValue;

      // Toggle active class within this option group
      document.querySelectorAll('.prod-option[data-option-index="' + idx + '"] .prod-opt-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      // Update displayed value
      var displayEl = document.querySelector('.prod-option[data-option-index="' + idx + '"] [data-option-display]');
      if (displayEl) displayEl.textContent = ' — ' + btn.dataset.optionValue;

      applyVariant();
    });
  });

  applyVariant();

  // Intercept the cart form submit — use /cart/add.js to avoid Shopify's
  // bot-verification page, then redirect to /cart.
  (function setupCartSubmit() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('prod-add-btn');
      var labelEl = document.getElementById('prod-add-label');
      var originalLabel = labelEl ? labelEl.textContent : '';
      if (btn) { btn.disabled = true; }
      if (labelEl) labelEl.textContent = '処理中...';
      var idInput = document.getElementById('prod-variant-id');
      var variantId = idInput ? idInput.value : null;
      if (!variantId) {
        if (btn) btn.disabled = false;
        if (labelEl) labelEl.textContent = originalLabel;
        return;
      }
      // AJAX add then redirect to /cart (cart page exists at /cart).
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          if (labelEl) labelEl.textContent = originalLabel;
          alert('カートに追加できませんでした。');
        });
    });
  })();

  // Thumbnail → main image swap.
  (function setupThumbs() {
    var main = document.querySelector('.prod-image--main');
    var mainImg = main ? main.querySelector('img') : null;
    var thumbs = document.querySelectorAll('.prod-image--thumb');
    if (!main || !mainImg || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-image-url');
        var id = thumb.getAttribute('data-image-id');
        if (!url) return;
        mainImg.src = url;
        main.setAttribute('data-image-id', id);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  })();

  // スマホ：メイン画像の横スライドとサムネイル列を連動させる
  (function setupMobileThumbs() {
    var track = document.querySelector('.prod-images');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.prod-thumb-m'));
    if (!track || !thumbs.length) return;
    var figs = Array.prototype.slice.call(track.querySelectorAll('.prod-image--main'));
    var current = 0;
    function mark(i) {
      if (i === current && thumbs[i].classList.contains('is-active')) return;
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i], row = t.parentElement;
      var left = t.offsetLeft - row.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
      row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var f = figs[i]; if (!f) return;
        track.scrollTo({ left: f.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        mark(i);
      });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth; if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i >= 0 && i < thumbs.length && i !== current) mark(i);
      });
    }, { passive: true });
  })();

  // Convert "■…" section headings in the description into <details> toggles.
  // Splits on lines starting with "■" and wraps each block in a collapsible.
  // Also ensures 商品仕様 and 注意事項 always exist (with placeholder fallback).
  (function setupDescToggles() {
    var desc = document.querySelector('.prod-desc');
    if (!desc) return;
    var raw = desc.innerText || desc.textContent || '';

    var lines = raw.split('\n');
    var sections = [];
    var current = null;
    var preamble = [];

    lines.forEach(function (line) {
      if (line.indexOf('■') === 0 || line.trimStart().indexOf('■') === 0) {
        if (current) sections.push(current);
        current = {
          title: line.replace(/^[\s　]*■[\s　]*/, '').trim(),
          body: []
        };
      } else if (current) {
        current.body.push(line);
      } else {
        preamble.push(line);
      }
    });
    if (current) sections.push(current);

    // Ensure these always exist (placeholder fallback). Match keywords flexibly
    // so e.g. "詳細サイズ" also satisfies "サイズ詳細".
    var requiredToggles = [
      { title: '商品仕様', keywords: ['商品仕様', '仕様'], placeholder: '情報を準備中です。' },
      { title: 'サイズ詳細（cm）', keywords: ['サイズ詳細', '詳細サイズ', 'サイズ'], placeholder: 'サイズ情報を準備中です。' },
      { title: '注意事項', keywords: ['注意事項', '注意'], placeholder: '※モニター環境により、実際の色味と異なる場合がございます。\n※お客様都合による返品・交換はお受けしておりません。' }
    ];
    requiredToggles.forEach(function (req) {
      var found = sections.some(function (s) {
        return req.keywords.some(function (kw) { return s.title.indexOf(kw) !== -1; });
      });
      if (!found) {
        sections.push({ title: req.title, body: req.placeholder.split('\n') });
      }
    });

    if (sections.length === 0) return;

    // Merge "ご注文について" content INTO 注意事項 toggle
    var mergeIntoCaution = [];
    var toggleSections = [];
    sections.forEach(function (sec) {
      if (sec.title === 'ご注文について') {
        mergeIntoCaution = mergeIntoCaution.concat(sec.body);
      } else {
        toggleSections.push(sec);
      }
    });
    if (mergeIntoCaution.length > 0) {
      var caution = null;
      for (var i = 0; i < toggleSections.length; i++) {
        if (toggleSections[i].title.indexOf('注意事項') !== -1) { caution = toggleSections[i]; break; }
      }
      if (caution) {
        if (caution.body.length > 0) caution.body.push('');
        caution.body = caution.body.concat(mergeIntoCaution);
      } else {
        toggleSections.push({ title: '注意事項', body: mergeIntoCaution });
      }
    }
    var inlineSections = [];

    // Preferred toggle order: 商品仕様 → サイズ詳細(any variant) → 注意事項 → rest
    var toggleOrderKeywords = [
      ['商品仕様', '仕様'],
      ['サイズ詳細', '詳細サイズ', 'サイズ'],
      ['注意事項', '注意']
    ];
    toggleSections.sort(function (a, b) {
      function rank(title) {
        for (var i = 0; i < toggleOrderKeywords.length; i++) {
          if (toggleOrderKeywords[i].some(function (kw) { return title.indexOf(kw) !== -1; })) return i;
        }
        return toggleOrderKeywords.length;
      }
      return rank(a.title) - rank(b.title);
    });

    // Render a multi-line block: blank lines become paragraph breaks,
    // single newlines become <br> (so tight line wraps stay tight while
    // intentional paragraph breaks get proper spacing via CSS).
    function renderBlock(text) {
      var paragraphs = text.split(/\n\s*\n+/);
      return paragraphs.map(function (p) {
        return '<p>' + escapeHtml(p.trim()).replace(/\n/g, '<br>') + '</p>';
      }).join('');
    }

    var html = '';
    var preambleText = preamble.join('\n').trim();
    if (preambleText) {
      html += '<div class="prod-desc-preamble">' + renderBlock(preambleText) + '</div>';
    }
    inlineSections.forEach(function (sec) {
      var body = sec.body.join('\n').replace(/^\s+|\s+$/g, '');
      html += '<div class="prod-desc-inline">' + renderBlock(body) + '</div>';
    });
    toggleSections.forEach(function (sec) {
      var body = sec.body.join('\n').replace(/^\s+|\s+$/g, '');
      html += '<details class="prod-desc-section">'
        + '<summary class="prod-desc-summary">'
        +   '<span>' + escapeHtml(sec.title) + '</span>'
        +   '<span class="prod-desc-icon" aria-hidden="true">+</span>'
        + '</summary>'
        + '<div class="prod-desc-body">' + renderBlock(body) + '</div>'
        + '</details>';
    });
    desc.innerHTML = html;

    function escapeHtml(s) {
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  })();
})();
